import React from 'react';
import Section from '../components/Section';
import ChipSelect from '../components/ChipSelect';
import TextField from '../components/TextField';

const EQUIPMENT_OPTIONS = [
  'Sealing machine',
  'Blender',
  'Refrigerator or chiller',
  'POS',
  'Printer',
  'Power cut',
  'No issues',
];

const NO_ISSUE_TAG = 'No issues';

function S3_Equipment({ data, onChange, errors }) {
  // Show mandatory follow-up when at least one real issue tag is selected
  const selected = data.equipment_issues || [];
  const hasRealIssue =
    selected.length > 0 && !selected.every((t) => t === NO_ISSUE_TAG);

  return (
    <Section title="Equipment">
      <ChipSelect
        label="Any equipment problems today?"
        options={EQUIPMENT_OPTIONS}
        selected={selected}
        onChange={(v) => onChange('equipment_issues', v)}
      />

      {/* MODIFIED — mandatory follow-up if any real issue tag selected */}
      {hasRealIssue && (
        <TextField
          label="Which equipment, what was the problem, was it resolved?"
          value={data.equipment_detail || ''}
          onChange={(v) => onChange('equipment_detail', v)}
          multiline
          maxLength={500}
          required
          hasError={!!errors.equipment_detail}
          errorMsg={errors.equipment_detail}
          placeholder="e.g. Sealing machine stopped working at 6pm — we used manual lids for the rest of the shift, engineer called"
        />
      )}

      <TextField
        label="Any other details?"
        value={data.equipment_notes || ''}
        onChange={(v) => onChange('equipment_notes', v)}
        multiline
        maxLength={200}
        placeholder="Optional — any additional notes"
      />
    </Section>
  );
}

export default S3_Equipment;
